export const FILE_MAX_SIZE_TO_IMPORT = 10000000; // 10 MB
export const CONFIRM_BUTTON_TITLE = 'Import URLs';
export const APPROVE_BUTTON_TEXT = 'Import';
